import { useEffect, useState } from "react";
import logoWhite from "../Assest/logo_png_with_shreebalajee (1).png";
import logoDark from "../Assest/logo_png_with_shreebalajee (1).png";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 w-full z-50 transition-all duration-300
        ${scrolled
          ? "bg-white/90 backdrop-blur shadow-md"
          : "bg-transparent"}
      `}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">

        {/* LOGO */}
        <img
          src={scrolled ? logoDark : logoWhite}
          alt="BingoPays"
          className="h-9 object-contain"
        />

        {/* DESKTOP MENU */}
        <div
          className={`hidden md:flex items-center gap-8 font-medium
            ${scrolled ? "text-gray-800" : "text-black"}
          `}
        >
          <a href="/" className="hover:text-indigo-500 transition">Home</a>
          <a href="/about" className="hover:text-indigo-500 transition">About</a>
          <a href="/products" className="hover:text-indigo-500 transition">Products</a>
          <a href="/contact" className="hover:text-indigo-500 transition">Contact</a>
        </div>

        {/* LOGIN BUTTON (SINGLE CLICK) */}
        <a
          href="https://portal.bingopayments.in"
          target="_blank"
          rel="noopener noreferrer"
          className={`hidden md:inline-flex items-center justify-center
            h-10 px-6 rounded-xl font-semibold transition
            ${scrolled
              ? "bg-indigo-600 text-white hover:bg-indigo-700"
              : "bg-white text-indigo-600 hover:bg-gray-100"}
          `}
        >
          Login
        </a>

        {/* HAMBURGER BUTTON */}
        <button
          className={`md:hidden relative w-9 h-9 flex flex-col justify-center items-center
            ${scrolled ? "text-gray-800" : "text-white"}
          `}
          onClick={() => setOpen(!open)}
        >
          <span
            className={`w-6 h-0.5 bg-current transition-all
              ${open ? "rotate-45 translate-y-1.5" : "-translate-y-1"}
            `}
          />
          <span
            className={`w-6 h-0.5 bg-current transition-all
              ${open ? "opacity-0" : "opacity-100"}
            `}
          />
          <span
            className={`w-6 h-0.5 bg-current transition-all
              ${open ? "-rotate-45 -translate-y-1.5" : "translate-y-1"}
            `}
          />
        </button>
      </div>

      {/* MOBILE MENU */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300
          ${open ? "max-h-screen opacity-100" : "max-h-0 opacity-0"}
        `}
      >
        <div className="bg-white px-6 py-6 space-y-5 shadow-xl rounded-b-3xl">

          <a href="/" className="block text-gray-800 font-medium">Home</a>
          <a href="/about" className="block text-gray-800 font-medium">About</a>
          <a href="/products" className="block text-gray-800 font-medium">Products</a>
          <a href="/contact" className="block text-gray-800 font-medium">Contact</a>

          <a
            href="https://portal.bingopayments.in"
            target="_blank"
            rel="noopener noreferrer"
            className="block text-center bg-indigo-600 text-white py-3 rounded-xl font-semibold hover:bg-indigo-700 transition"
          >
            Login
          </a>
        </div>
      </div>
    </nav>
  );
}

